import { render, staticRenderFns } from "./VDocument.vue?vue&type=template&id=4dc72b19&lang=pug"
import script from "./VDocument.vue?vue&type=script&lang=ts"
export * from "./VDocument.vue?vue&type=script&lang=ts"
import style0 from "./VDocument.vue?vue&type=style&index=0&id=4dc72b19&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports